import React, { Component } from 'react';
import { connect } from 'react-redux';
import { List } from 'semantic-ui-react';

import 'Styles/components/validation-banner.less';

class ValidationBannerContainer extends Component {
  renderBanner = errors => {
    return (
      <div className="validation-banner-container">
        <span>The form below contains errors:</span>
        <List as="ul">
          {[
            ...Object.keys(errors).map(key => (
              <List.Item key={key} as="li">
                {errors[key]}
              </List.Item>
            )),
          ]}
        </List>
      </div>
    );
  };

  render() {
    const { errors } = this.props;

    return !Object.keys(errors).length ? null : this.renderBanner(errors);
  }
}

const ValidationBanner = connect()(ValidationBannerContainer);

export { ValidationBanner };



// WEBPACK FOOTER //
// ./src/components/messages/ValidationBanner.js